<template>
  <v-container fluid>
    <v-card flat tile :dark="dark">
      <v-card-title class="text-h5 font-weight-bold">
        Pedido #{{ orderPolling.displayId }} - {{ orderPolling.customer.name }}
      </v-card-title>
      <v-card-subtitle>
        Feito às
        {{
          new Date(orderPolling.createdAt)
            .toLocaleTimeString('pt-BR')
            .substr(0, 5)
        }}
        ●
        {{
          orderPolling.customer.phone
            ? `Localizador do pedido ${orderPolling.customer.phone.localizer}`
            : null
        }}
        ● {{ 'O que é isso?' }}
        <v-chip small class="red white--text">{{
          sponsors.filter((v) => v.id == orderPolling.salesChannel)[0].title
        }}</v-chip>
      </v-card-subtitle>
    </v-card>
    <v-card flat tile class="mb-2">
      <v-btn small class="mx-1">
        <v-icon small left>
          mdi-clock-outline
        </v-icon>
        {{ cmpDeliveryTimeText }}</v-btn
      >
      <v-btn small class="mx-1">
        <v-icon small left>mdi-star-four-points</v-icon>
        {{ cmpCustomerInfoText }}
      </v-btn>
      <v-btn small class="mx-1">
        <v-icon small left>mdi-phone-outline</v-icon>
        {{ $t('ifood.entrarContato') }}
      </v-btn>
    </v-card>
    <v-row dense>
      <template v-if="orderPolling">
        <v-col>
          <v-card tile>
            <v-container fluid>
              <div v-if="orderPolling.orderType == 'DELIVERY'">
                <v-card-title class="text-body-2">
                  <div class="d-flex text-wrap align-center">
                    <v-chip
                      small
                      class="mr-3 card-selected"
                      :class="
                        orderPolling.delivery.deliveredBy == 'MERCHANT'
                          ? 'deep-purple darken-4  white--text'
                          : 'red'
                      "
                    >
                      <v-icon left class=" white--text">
                        {{ cmpTipoPrevisaoEntrega.icon }}</v-icon
                      >
                      Entrega
                      {{
                        orderPolling.delivery.deliveredBy == 'MERCHANT'
                          ? 'Própria'
                          : 'iFood'
                      }}
                    </v-chip>
                    {{
                      getFormattedAddress(orderPolling.delivery.deliveryAddress)
                    }}
                  </div>
                </v-card-title>
                <div v-if="orderPolling.delivery.observations">
                  <div
                    class="text-body-2 black--text backgroundColor: blue-grey lighten-5 ml-6 pa-4 rounded"
                  >
                    <v-icon left color="black">mdi-map</v-icon>
                    {{ orderPolling.delivery.observations }}
                  </div>
                </div>
              </div>
              <div v-else-if="orderPolling.orderType == 'INDOOR'">
                <v-chip small color="deep-purple darken-4">
                  <v-icon>mdi-store-outline</v-icon>
                </v-chip>
              </div>
              <div v-else>
                <v-chip small color="deep-purple darken-4">
                  <v-icon left>
                    {{ cmpTipoPrevisaoEntrega.icon }}
                  </v-icon>
                  {{ $t('tiposEntrega.retirar') }}
                </v-chip>
                {{ $t('ifood.mensagemRetira') }}
              </div>
            </v-container>
          </v-card>
        </v-col>
      </template>
    </v-row>
    <v-card class="pa-2">
      <v-card-title>{{ $t('ifood.dadosPedido') }}</v-card-title>
      <v-card-text>
        <v-sheet
          v-if="infoTopCardDetails"
          color="blue-grey lighten-5"
          class="pa-3"
        >
          <span class="text-body-2  black--text rounded"
            >{{ infoTopCardDetails }}
          </span>
        </v-sheet>
        <v-card v-for="(item, index) in itemsList" :key="index" flat tile>
          <v-row dense>
            <v-col cols="10">
              <div class="d-flex text-wrap text-subtitle-1 font-weight-bold">
                {{ item.quantity }}x {{ item.name }}
              </div>
            </v-col>
            <v-col cols="2">
              <div class="d-flex justify-end text-subtitle-1 font-weight-bold">
                {{ formatCurrency(0, item.totalPrice) }}
              </div>
            </v-col>
          </v-row>
          <template v-if="item.options">
            <v-card
              class="ml-6"
              v-for="(option, index) in item.options"
              :key="index"
              flat
              tile
            >
              <v-row dense>
                <v-col cols="10">
                  <div class="d-flex text-wrap text-body-1">
                    {{ option.quantity }}x
                    {{ option.name }}
                  </div>
                </v-col>
                <v-col cols="2">
                  <div class="d-flex justify-end text-body-1">
                    {{ formatCurrency(0, option.price) }}
                  </div>
                  <div
                    v-if="option.observations"
                    class="d-flex text-wrap text-body-1 backgroundColor: grey"
                  >
                    {{ option.observations }}
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </template>
          <div
            v-if="item.observations"
            class="d-flex text-wrap text-body-1 black--text backgroundColor: grey ml-6 pa-4 rounded"
          >
            <v-icon left color="black">mdi-pencil</v-icon>
            {{ item.observations }}
          </div>
        </v-card>
      </v-card-text>
      <div v-if="orderPolling.total.deliveryFee > 0">
        <v-divider></v-divider>
        <v-card-text>
          <v-card flat tile>
            <div class="d-flex justify-space-between text-body-1">
              <div>
                <v-icon left>mdi-racing-helmet</v-icon
                >{{ $t('labels.itemDelivery') }}
              </div>
              <div>
                {{ formatCurrency(0, orderPolling.total.deliveryFee) }}
              </div>
            </div>
          </v-card>
        </v-card-text>
      </div>
      <div v-if="additionalFees && additionalFees.length > 0">
        <v-divider></v-divider>
        <v-card flat tile>
          <v-card-text v-for="(item, index) in additionalFees" :key="index">
            <v-card flat tile>
              <div class="d-flex justify-space-between text-body-1">
                <div>
                  <v-icon left>mdi-alert</v-icon>{{ $t('labels.itemFee') }}
                </div>
                <div>
                  {{ formatCurrency(0, item.value) }}
                </div>
              </div>
            </v-card>
          </v-card-text>
        </v-card>
      </div>
      <v-divider></v-divider>
      <v-card-text>
        <v-card flat tile>
          <div class="d-flex justify-space-between text-h6 font-weight-bold">
            <div>Total Pedido</div>
            <div>
              {{ formatCurrency(0, totalOrder) }}
            </div>
          </div>
        </v-card>
      </v-card-text>
      <div v-for="benefit in ifoodBenefits" :key="benefit.sponsor.id">
        <v-divider></v-divider>
        <v-card-text>
          <v-card flat tile>
            <v-row dense>
              <v-col cols="10">
                <div class="d-flex">
                  <div v-if="benefit.sponsor.id == 'IFOOD'" class="d-flex">
                    <v-img
                      class="mt-1 mr-2"
                      position="top"
                      max-width="24"
                      contain
                      src="/images/logo_integracoes/ifood-black.ico"
                    ></v-img>
                  </div>
                  <div v-else>
                    <v-icon large>mdi-store-outline</v-icon>
                  </div>
                  <div class="flex-column">
                    <div class="text-subtitle-1 font-weight-bold">
                      {{ benefit.sponsor.title }}
                    </div>
                    <div class="text-body-2 font-weight-regular">
                      {{ benefit.sponsor.subtitle }}
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="2">
                <div
                  class="d-flex justify-end text-subtitle-1 font-weight-bold"
                >
                  {{ formatCurrency(0, benefit.value) }}
                </div>
              </v-col>
            </v-row>
            <v-card-text>
              <v-card
                v-for="(item, index) in benefit.benefits"
                :key="index"
                flat
                tile
              >
                <v-row dense>
                  <v-col cols="10">
                    <div class="offset-1">
                      <div
                        class="d-flex text-wrap text-body-1 font-weight-bold"
                      >
                        {{
                          targets.filter((v) => v.id == item.target)[0].title
                        }}
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="2">
                    <div class="d-flex justify-end body-1 font-weight-bold">
                      {{ formatCurrency(0, item.value) }}
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-card-text>
          </v-card>
        </v-card-text>
      </div>
    </v-card>
    <v-card class="mt-3">
      <v-card-text>
        <v-card
          v-for="(item, index) in cmpPaymentInfoText"
          :key="index"
          flat
          tile
        >
          <v-row dense>
            <v-col cols="10">
              <div class="d-flex">
                <v-img
                  class="mt-1 mr-2"
                  position="top"
                  max-width="32"
                  contain
                  :src="
                    item.message && item.message.brand
                      ? item.message.brand.flagSrc
                      : ''
                  "
                ></v-img>
                <div class="flex-column">
                  <div class="text-subtitle-1 font-weight-bold">
                    {{ item.message.title }} - {{ item.type }}
                  </div>
                  <div class="text-body-2 font-weight-regular">
                    {{ item.message.subtitle }}
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="2">
              <div class="d-flex justify-end text-subtitle-1 font-weight-bold">
                {{ formatCurrency(0, item.value) }}
              </div>
            </v-col>
          </v-row>
          <template v-if="item.options">
            <v-card
              class="ml-6 pl-1"
              v-for="(option, index) in item.options"
              :key="index"
              flat
              tile
            >
              <v-divider />
              <v-row dense>
                <v-col cols="10">
                  <div
                    class="d-flex text-wrap text-body-1 font-weight-bold align-center pa-3"
                  >
                    {{ option }}
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </template>
          <template v-if="orderPolling.customer.documentNumber">
            <v-divider />
            <v-card-text>
              <v-card class="ml-6" flat tile>
                <div class="d-flex text-wrap text-body-1 font-weight-bold">
                  Incluir CPF na nota fiscal
                  {{ orderPolling.customer.documentNumber }}
                </div>
              </v-card>
            </v-card-text>
          </template>
        </v-card>
      </v-card-text>
    </v-card>
    <v-card class="mt-3">
      <v-card-actions>
        <div
          v-if="
            eventPolling && canceledCodes.lastIndexOf(eventPolling.code) == -1
          "
        >
          <v-btn
            v-if="!disableCancelButton"
            outlined
            class="white--text text-caption"
            color="red"
            @click.prevent="showCancelDialog()"
          >
            {{ $t('ifood.buttons.cancelOrder') }}
          </v-btn>
          <v-dialog
            v-model="dialogOptionsCancelOrder"
            max-width="500px"
            transition="dialog-bottom-transition"
          >
            <v-card>
              <v-toolbar dark color="red" dense flat>
                <v-toolbar-title class="white--text">
                  Motivo Cancelamento
                </v-toolbar-title>
              </v-toolbar>

              <v-card-text>
                <v-container fluid>
                  <v-radio-group v-model="optionCancelOrder">
                    <template v-slot:label>
                      <div>
                        Escolha uma das opções abaixo
                      </div>
                    </template>
                    <v-radio
                      v-for="option in optionsToCancelOrder"
                      :key="option.id"
                      :label="option.title"
                      :value="option.id"
                      dense
                      class="customClass"
                    ></v-radio>
                  </v-radio-group>
                </v-container>
              </v-card-text>
              <form-buttons
                @goBack="closeDialogCancel()"
                @submitForm="cancelOrder(optionCancelOrder)"
              />
            </v-card>
          </v-dialog>
        </div>
        <v-spacer />
        <!-- <v-btn
          class="red white--text text-caption"
          @click="btnAction('confirmOrder')"
        >
          {{ $t('ifood.buttons.confirmOrder') }}
        </v-btn>
        <v-btn
          class="warning white--text text-caption"
          @click="startButton('startPreparationOrder')"
        >
          {{ $t('ifood.buttons.startPreparationOrder') }}
        </v-btn>
        <v-btn
          class="indigo white--text text-caption"
          @click="btnAction('readyToPickupOrder')"
        >
          {{ $t('ifood.buttons.readyToPickupOrder') }}
        </v-btn>
        <v-btn
          color="success white--text text-caption"
          @click="btnAction('dispatchOrder')"
        >
          {{ $t('ifood.buttons.dispatchOrder') }}
        </v-btn> -->
        <div v-if="eventPolling">
          <div v-for="button in actionButtons" :key="button.id">
            <div
              v-if="
                eventPolling.code == button.conditionType &&
                  eventPolling.code != 'DSP' &&
                  !eventPolling.isWait &&
                  button.visible
              "
            >
              <div
                v-if="
                  eventPolling.code == button.conditionType &&
                    eventPolling.code != 'DSP'
                "
              >
                <div
                  v-if="
                    button.orderType.lastIndexOf(eventPolling.order.orderType) >
                      0
                  "
                >
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-on="on"
                        v-bind="attrs"
                        :class="button.class"
                        @click="btnAction(button.action, eventPolling)"
                      >
                        <v-icon left>{{ button.icon }}</v-icon>
                        <div v-if="!$vuetify.breakpoint.mobile">
                          {{ button.title }}
                        </div>
                      </v-btn>
                    </template>
                    <span>{{ button.title }}</span>
                  </v-tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card-actions>
    </v-card>
    <confirm :persistent="true" ref="confirm" v-model="confirm"></confirm>
  </v-container>
</template>
<script>
import { currencyMixin } from '@/mixins/object/currency/CurrencyMixin'
import { ifoodMixin } from '@/mixins/object/integration/iFood/IfoodMixin'
import { mapState, mapActions, mapGetters } from 'vuex'
import FormButtons from '@/components/shared/base-buttons/FormButtons'
import Confirm from '@/components/shared/base-dialog/Confirm.vue'

export default {
  name: 'OrderDetails',
  mixins: [currencyMixin, ifoodMixin],
  components: {
    FormButtons,
    Confirm,
  },
  props: {
    startButton: Function,
    cancelButton: Function,
    btnAction: Function,
    dark: Boolean,
  },
  data() {
    return {
      confirm: false,
      dialogOptionsCancelOrder: false,
      optionCancelOrder: null,
    }
  },
  computed: {
    ...mapState('ifoodModule', ['orderPolling', 'eventPolling']),
    ...mapGetters({
      optionsToCancelOrder: 'ifoodModule/getOptionsToCancelOrder',
    }),

    disableCancelButton() {
      if (this.btnAction === undefined) return true

      const events = ['CON', 'CAN', 'CAR']

      const pos = events.lastIndexOf(this.eventPolling.code) != -1

      return pos
    },
    itemsList() {
      return this.orderPolling && this.orderPolling.items
        ? this.orderPolling.items
        : []
    },

    totalOrder() {
      const { orderAmount, benefits } = this.orderPolling.total
      return orderAmount + benefits
    },

    fakeBenefits() {
      return [
        {
          value: 10,
          target: 'CART',
          sponsorshipValues: [
            {
              name: 'IFOOD',
              value: 0,
            },
            {
              name: 'MERCHANT',
              value: 10,
            },
          ],
        },
        {
          value: 4.99,
          target: 'DELIVERY_FEE',
          sponsorshipValues: [
            {
              name: 'IFOOD',
              value: 4.99,
            },
            {
              name: 'MERCHANT',
              value: 0,
            },
          ],
        },
        {
          value: 4.99,
          target: 'ITEM',
          targetId: '1',
          sponsorshipValues: [
            {
              name: 'IFOOD',
              value: 4.99,
            },
            {
              name: 'MERCHANT',
              value: 0,
            },
          ],
        },
      ]
    },

    targets() {
      return [
        {
          id: 'CART',
          title: 'Cupom Desconto',
          // 'Cupom Desconto é aplicado sobre o subtotal do carrinho (somatório dos itens do pedido).',
        },
        {
          id: 'DELIVERY_FEE',
          title: 'Taxa de entrega',
          //	Desconto é aplicado sobre a taxa de entrega.
        },
        {
          id: 'ITEM',
          title: 'Desconto item',
          // 'Desconto é aplicado sobre um item específico do carrinho. O campo targetId específica sobre qual item o desconto foi aplicado. Essa especificação é feita na configuração da campanha.',
        },
        {
          id: 'PROGRESSIVE_DISCOUNT_ITEM',
          title: 'Desconto progressivo itens',
          // 'Desconto progressivo em itens iguais do pedido, formando um combo.',
        },
      ]
    },

    benefitsMessages() {
      return [
        {
          id: 'IFOOD',
          title: 'Incentivos iFood',
          subtitle: 'O iFood arca com este desconto',
        },
        {
          id: 'MERCHANT',
          title: 'Incentivos e cobranças da Loja',
          subtitle: 'Valores cobrados da sua loja',
        },
      ]
    },

    additionalFees() {
      return this.orderPolling.additionalFees

      // const add = [
      //   {
      //     type: 'SMALL_ORDER_FEE',
      //     title: 'taxa de serviço para pedidos abaixo do valor mínimo',
      //     value: 1.0,
      //   },
      //   {
      //     type: 'MERCHANT_SUBSCRIPTION_FEE',
      //     title: 'valor da taxa de serviço',
      //     value: 5.0,
      //   },
      // ]
      // return add
    },

    ifoodBenefits() {
      var list = []

      if (this.orderPolling.benefits)
        this.sponsors.forEach((sponsor) => {
          const benefit = this.filterBenefit(
            this.orderPolling.benefits,
            sponsor
          )
          if (benefit.value != 0) list.push(benefit)
        })

      return list
    },

    infoTopCardDetails() {
      if (!this.eventPolling) return ''
      const expirationTime = this.getExpirationTime(this.eventPolling)
      const infoTopCard = this.getInfoTopCard(this.eventPolling)
      if (this.orderPolling.orderTiming == 'SCHEDULED')
        return infoTopCard.message

      return `${infoTopCard.message} há ${
        expirationTime.hour > 0 ? expirationTime.hour + 'h' : ''
      } ${expirationTime.minute} min`
    },
  },
  methods: {
    ...mapActions({
      cancelOrderIfood: 'ifoodModule/cancelOrder',
      getOrderCancellationReasons: 'ifoodModule/getOrderCancellationReasons',
      updateList: 'ifoodModule/updateList',
    }),

    getSponsorBenefitTitle(sponsor) {
      return this.benefitsMessages.filter((v) => v.id == sponsor)[0]
    },
    filterBenefit(benefits, sponsor) {
      var list = []

      benefits.forEach((v) => {
        const values = v.sponsorshipValues.filter(
          (sp) => sp.name == sponsor.id && sp.value > 0
        )[0]

        if (values) {
          list.push({
            value: v.value * -1,
            target: v.target,
          })
        }
      })

      const total = list.reduce((total, benefit) => {
        return (total += benefit.value)
      }, 0.0)

      const titles = this.getSponsorBenefitTitle(sponsor.id)

      const obj = {
        sponsor: titles,
        value: total,
        benefits: list,
      }

      return obj
    },
    async cancelOrder(optionId) {
      if (!optionId) {
        this.$toasted.error('Selecione um motivo para continuar!', {
          duration: 3000,
        })
      } else if (
        await this.$refs.confirm.open(
          this.$i18n.t('labels.cancelar'),
          this.$i18n.t('dialogs.actions', {
            action: this.$i18n.t('labels.cancelar'),
            nome: 'Pedido',
            codigo: this.orderPolling.displayId,
          }),
          { color: 'red' }
        )
      ) {
        const option = this.optionsToCancelOrder.filter(
          (v) => v.id == optionId
        )[0]
        const payload = {
          orderId: this.orderPolling.id,
          cancellationCode: optionId.toString(),
          reason: option.title,
          eventId: this.eventPolling.id,
        }
        try {
          this.setLoadingDialogMessage('Enviando requisição...')
          this.showLoadingDialog(true)

          const { data } = await this.cancelOrderIfood(payload)

          if (data.error) throw data.error
          else {
            this.updateList({
              action: 'cancelOrder',
              event: this.eventPolling,
            })
            this.$toasted.success(data, { duration: 5000 })
          }
          this.closeDialogCancel()
        } catch (error) {
          this.$toasted.error(error, { duration: null })
        } finally {
          this.showLoadingDialog(false)
        }
      } else {
        return
      }
    },
    async showCancelDialog() {
      const payload = {
        orderId: this.orderPolling.id,
        eventId: this.eventPolling.id,
      }

      try {
        // obter lista de motivos de cancelamentos primeiro
        this.showLoadingDialog(true)
        await this.getOrderCancellationReasons(payload)

        if (this.optionsToCancelOrder.length > 0)
          this.dialogOptionsCancelOrder = true
        else
          throw 'Não é possível efetuar o cancelamento do pedido! Verifique cancelamentos disponíveis no Portal do Parceiro iFood!'
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      } finally {
        this.showLoadingDialog(false)
      }
    },
    closeDialogCancel() {
      this.dialogOptionsCancelOrder = !this.dialogOptionsCancelOrder
    },
  },
}
</script>
